import styled from "@emotion/styled";

import { Flexbox } from "../../core/components";

export const SpinnerContainer = styled(Flexbox)`
    padding: 64px 0;
`;
